import * as React from "react";
import { db } from "../../firebase";
import { withAuthorization } from "../../firebase/withAuthorization";
import { UserList } from "../../pills/users/UserList";
import { UserAddForm } from "../../pills/users/userAddForm";
import {  Header , Modal , Button, Icon } from 'semantic-ui-react'


class UsersComponent extends React.Component {
  constructor(props: any) {
    super(props);

    this.state = {
      users: null,
      modalOpen : false,
      modalDeleteOpen : false,
      currentUser : null
    };

    this.handleDeleteUser = this.handleDeleteUser.bind(this)
    this.doActivateUser = this.doActivateUser.bind(this)
    this.handleAddUser = this.handleAddUser.bind(this)


  }

  public componentDidMount() {
    db.onceGetUsers().then(snapshot =>
      this.setState(() => ({ users: snapshot.val() }))
    );
  }

  public handleAddUser(){
      db.onceGetUsers().then(snapshot =>
      this.setState(() => ({ users: snapshot.val() ,
      modalOpen: false}))
    );
  }


  handleDeleteUser(user ?: any){
      this.setState(() => ({ 
        modalDeleteOpen: true,
        currentUser: user
      }))
  }

  doActivateUser (currentUser ?:any){
    db.doActivateUser(currentUser.id)
    .then(() => {
          console.log("User Activated")
          db.onceGetUsers().then(snapshot =>
          this.setState(() => ({ users: snapshot.val() , modalDeleteOpen: false })) )
      })
      .catch(error => {
          console.log("error catched")
      }); 
  }
  
  onDeleteUser(currentUser ?: any){
    db.doDeleteUser(currentUser.id)
    .then(() => {
          console.log("User Deleted")
          db.onceGetUsers().then(snapshot =>
          this.setState(() => ({ users: snapshot.val() , modalDeleteOpen: false })) )
      })
      .catch(error => {
          console.log("error catched")
      });   
  }

  handleDeleteClose = () => this.setState({ modalDeleteOpen: false })
  handleOpen = () => this.setState({ modalOpen: true })

  public render() {
    const { users, modalOpen, modalDeleteOpen, currentUser }: any = this.state;

    return (
      <div>
          <Header as='h2'>List of Users
                <Modal 
                  open={modalOpen}
                  trigger={
                  <Button size='tiny' onClick={this.handleOpen} style={{ marginLeft : '20px' }} positive>Add User</Button>
                    }>
                    <Modal.Header>Add User</Modal.Header>
                    <Modal.Content>
                      <UserAddForm onUserAdded = {this.handleAddUser}/>
                    </Modal.Content> 
                </Modal>
          </Header>
          <Modal 
            open={modalDeleteOpen} >
              <Modal.Header>Delete User</Modal.Header>
                <Modal.Content>
                  Are you sure you want to delete this User?
                </Modal.Content>
                <Modal.Actions>
                  <Button color='green'  onClick={this.handleDeleteClose}>
                    <Icon name='remove'  /> No
                  </Button>
                  <Button color='red' onClick={() => this.onDeleteUser(currentUser)} >
                    <Icon name='checkmark'/> Yes
                  </Button>
            </Modal.Actions>
          </Modal>
          {!!users && <UserList onActivateUser= {this.doActivateUser} onDeleteUser= {this.handleDeleteUser} users={users} />}
      </div>
    );
  }
}

const authCondition = (authUser: any) => !!authUser ;

export const UsersPage = withAuthorization(authCondition)(UsersComponent);


// WEBPACK FOOTER //
// ./src/pages/Users/index.tsx